<div class="wrap">
  <h2>Listes des lieux de pratique du club:</h2>

  <ng-container [ngSwitch]="data.typeList">
    <ul>
      <li *ngFor="let pp of data.list"><strong>{{pp.postalCode}} {{pp.city}}</strong> {{pp.postalCode || pp.city ? '-' : null }} {{pp.box}} {{pp.box? ',' : null}} {{pp.address}}</li>
    </ul>
  </ng-container>
  <div class="btn_action">
    <button (click)="dialogRef.close()" appChangeColorTheme attribute="bgc">Fermer</button>
  </div>
</div>
